// Constant
import {
  UPDATE_CANDIDATES_DATA_SETTINGS,
  FETCH_CANDIDATES_DATA_REQUEST,
  CANDIDATES_RESET_STATE
  } from '../../../modules/actions'
import api from '../../../modules/api'

// Action
export const initialState = {
  isLoading: true,
  proposals: [],
  status: '',
  graph_data: [],
  meta_data: {
    proposals_count: 0,
    sort_data: {},
    doctor_seen_count: 0
  },
  // images and annotation
  photoIndex: 0,
  openImageAnnotationModal: false,
  first_accept: '',
  // active doctor id (highlight doctor)
  activeDoctorId: null,
  sortBy: ''
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATES_RESET_STATE:
      return initialState
    case UPDATE_CANDIDATES_DATA_SETTINGS:
      return  {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export const resetState = () => {
  return {
    type: CANDIDATES_RESET_STATE
  }
}

export const  fetchCandidatesDataRequest = () => ({
  type: FETCH_CANDIDATES_DATA_REQUEST
})

export const updateCandidatesDataSetting = (payload) => ({
  type: UPDATE_CANDIDATES_DATA_SETTINGS,
  payload
})

export function nextAnnotationImage(callback) {
 return async (dispatch, getState) => {
    let state = getState()
    let photoIndex = state.candidates.photoIndex
    let fileData = state.signup.fileData
    let images = fileData.imgFiles ? fileData.imgFiles : []
    let newPhotoIndex = (photoIndex + 1) % images.length
    let image = images[newPhotoIndex]
    dispatch(updateCandidatesDataSetting({
      photoIndex: newPhotoIndex
    }))

    dispatch(fetchAnnotations(image, callback))
  }
}

export function prevAnnotationImage(callback) {
 return async (dispatch, getState) => {
    let state = getState()
    let photoIndex = state.candidates.photoIndex
    let fileData = state.signup.fileData
    let images = fileData.imgFiles ? fileData.imgFiles : []
    let newPhotoIndex = (photoIndex + images.length - 1) % images.length
    let image = images[newPhotoIndex]
    dispatch(updateCandidatesDataSetting({
      photoIndex: newPhotoIndex
    }))

    dispatch(fetchAnnotations(image, callback))
  }
}

// Thunks
export function fetchAnnotations(file, callback) {
  return async (dispatch, getState) => {
    let response = await api.fetchAnnotations(file.id)

    let data = response.data
    let annotations = data.annotations
    let doctors = data.doctors

    annotations = annotations.map(item => annotationParser(item, doctors))

    let state = getState()
    let activeDoctorId = state.candidates.activeDoctorId

    callback(
      {
        annotations,
        doctors,
        activeAnnotations: activeDoctorId ? [activeDoctorId] : []
      }
    )
  }
}

const annotationParser = (item, doctors) => {
  let doctorId = item.doctor_id
  let activeDoctorIndex = doctors.findIndex(doctor => doctor.id === doctorId)
  let activeDoctor = doctors[activeDoctorIndex]
  let color = activeDoctor.color
  return {
    ...item,
    color: color
  }
}

export function fetchFileDownload(file, downloadLink) {
  if(!file) return
  return async (dispatch, getState) => {
    let response = await api.fetchFileData(file.id, "cleaned")
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    // # NOTE: Comment out due to an error
    // # Not allowed to navigate top frame to data URL
    // if (detect().mobile) {
    //   const reader = new FileReader()
    //   reader.onload = function (e) {
    //     window.location.href = reader.result
    //   }
    //   reader.readAsDataURL(blob)
    // } else
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, file.cleaned_file_name);
    } else {
      const data = window.URL.createObjectURL(blob);
      dispatch(updateCandidatesDataSetting({
        downloadFileData: data
      }))
      downloadLink.click()
    }
  }
}

export function openDoctorAnnotationModal(doctorId) {
  return (dispatch, getState) => {
    dispatch(updateCandidatesDataSetting({
      activeDoctorId: doctorId.substr(2),
      photoIndex: 0,
      openImageAnnotationModal: true
    }))
  }
}

export function sortProposalsBy(sortBy) {
  return async (dispatch, getState) => {
    dispatch(updateCandidatesDataSetting({
      sortBy: sortBy
    }))
  }
}



// WEBPACK FOOTER //
// ./src/routes/candidates/modules/candidates.js